import { ISessionAction } from 'app_state/types';
import sessionActionTypes from 'app_state/session/actionTypes';

export default () : ISessionAction => ({
  payload: null,
  type: sessionActionTypes.RESET_STATE,
});
